angular
  .module('surfsightApp.controllers')
  .controller('EdgeShareBroadcastController', [
    '$scope',
    '$http',
    '$localStorage',
    '$mdDialog',
    '$mdToast',
    '$timeout',
    '$filter',
    'edgeFactory',
    'dataFromCaller',
    '$rootScope',
    function (
      $scope,
      $http,
      $localStorage,
      $mdDialog,
      $mdToast,
      $timeout,
      $filter,
      edgeFactory,
      dataFromCaller,
      $rootScope
    ) {
      let $translate = $filter('translate')
      $scope.data = $rootScope.data
      $scope.dashcamStream = dataFromCaller.dashcamStream
      let otuRequest = {}
      otuRequest.front = false
      otuRequest.rear = false
      $scope.sharingData = {
        email: null
      }
      $scope.parse_broadcast = function () {
        otuRequest.cameraName = $scope.dashcamStream.cameraName
        otuRequest.cameraSerial = $scope.dashcamStream.serialNumber
        if ($scope.dashcamStream.streamId === 1) {
          otuRequest.front = true
        } else if ($scope.dashcamStream.streamId === 2) {
          otuRequest.rear = true
        }
      }
      $timeout(function () {
        $scope.parse_broadcast()
      }, 1000)
      $scope.createOTU_sendEmail = function () {
        otuRequest.receiverEmail = $scope.sharingData.email
        otuRequest.receiverReason = $scope.sharingData.reason
        var requestJson = {
          method: 'POST',
          url: OTU_BASEURL + '/createOtu',
          data: otuRequest
        }
        $http(requestJson).then(
          function (response) {
            if (response.data.status.code === 0) {
              $mdDialog.hide(response)
            } else {
              $scope.showMessageToast($translate('internalErrorWhileSavingOTU'))
            }
          },
          response => $scope.$emit('handleServerError', response)
        )
      }
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action('ok')
          .position('bottom middle')
          .hideDelay(3000)
          .actionKey('F1')
          .parent('#share-multiple-broadcasts-container')

        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
              // alert('You clicked the \'UNDO\' action.');
            }
          })
          .catch(() => {})
      }
      $scope.cancel = function () {
        $mdDialog.cancel()
      }
    }
  ])
